import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';

import { AuthGuard } from './../../auth/auth-guard.service';
import { AdminAuthGuard } from './../../auth/admin-auth-guard.service';
import { AppAuthService } from './../../auth/auth.service';

import { HomeComponent } from '../../components/home/home.component';
import { LoginComponent } from '../../components/login/login.component';
import { NoAccessComponent } from '../../components/no-access/no-access.component';
import { AdminComponent } from '../../components/admin/admin.component';
import { CollanaSearchComponent } from '../../components/collana/collana-search/collana-search.component';
import { CollanaPreviewComponent } from '../../components/collana/collana-preview/collana-preview.component';
import { CollanaFormComponent } from '../../components/collana/collana-form/collana-form.component';
import { BookSearchComponent } from '../../components/book/book-search/book-search.component';
import { BookFormComponent } from '../../components/book/book-form/book-form.component';
import { ServizioStampaComponent } from '../../components/book/servizio-stampa/servizio-stampa.component';
import { RecensioneFormComponent } from '../../components/recensione/recensione-form/recensione-form.component';
import { TestataSearchComponent } from '../../components/testata/testata-search/testata-search.component';
import { TestataFormComponent } from '../../components/testata/testata-form/testata-form.component';
import { ArticoloSearchComponent } from '../../components/articolo/articolo-search/articolo-search.component';
import { ArticoloFormComponent } from '../../components/articolo/articolo-form/articolo-form.component';
import { ExtraFormComponent } from '../../components/extra/extra-form/extra-form.component';
import { ContributorFormComponent } from '../../components/contributor/contributor-form/contributor-form.component';
import { ContributorSearchListComponent } from '../../components/contributor/contributor-search-list/contributor-search-list.component';
import { CoversUploaderComponent } from '../../helpers/covers-uploader/covers-uploader.component';
import { CopertinarioComponent } from '../../helpers/copertinario/copertinario.component';

// ====== TEST ======
import { FormValidationSampleComponent } from '../../test/form-validation-sample/form-validation-sample.component';
import { FormValidationCustomComponent } from '../../test/form-validation-custom/form-validation-custom.component';

const routes: Routes = [
  { path: '', redirectTo: '/book/search', pathMatch: 'full' },
  { path: 'admin', component: AdminComponent, canActivate: [AdminAuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'no-access', component: NoAccessComponent },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'testata/search', component: TestataSearchComponent, canActivate: [AuthGuard] },
  { path: 'testata/:codice', component: TestataFormComponent, canActivate: [AuthGuard] },
  { path: 'testata', component: TestataFormComponent, canActivate: [AuthGuard] },
  { path: 'articolo/search', component: ArticoloSearchComponent, canActivate: [AuthGuard] },
  { path: 'articolo/:id', component: ArticoloFormComponent, canActivate: [AuthGuard] },
  { path: 'articolo', component: ArticoloFormComponent, canActivate: [AuthGuard] },
  { path: 'collana/search', component: CollanaSearchComponent, canActivate: [AuthGuard] },
  { path: 'collana/preview/:codice', component: CollanaPreviewComponent, canActivate: [AuthGuard] },
  { path: 'collana/:codice', component: CollanaFormComponent, canActivate: [AuthGuard] },
  { path: 'collana', component: CollanaFormComponent, canActivate: [AuthGuard] },
  { path: 'contributor/search', component: ContributorSearchListComponent, canActivate: [AuthGuard] },
  { path: 'contributor/:codice', component: ContributorFormComponent, canActivate: [AuthGuard] },
  { path: 'contributor', component: ContributorFormComponent, canActivate: [AuthGuard] },
  { path: 'upload-covers', component: CoversUploaderComponent, canActivate: [AuthGuard] },
  { path: 'copertinario', component: CopertinarioComponent, canActivate: [AuthGuard] },
  { path: 'book/search', component: BookSearchComponent, canActivate: [AuthGuard] },
  { path: 'book/:ean13', component: BookFormComponent, canActivate: [AuthGuard] },
  { path: 'book', component: BookFormComponent, canActivate: [AuthGuard] },
  { path: 'clone-book/:ean13', component: BookFormComponent, canActivate: [AuthGuard] },
  { path: 'servizio-stampa/:ean13', component: ServizioStampaComponent, canActivate: [AuthGuard] },
  { path: 'recensioni/:ean13', component: RecensioneFormComponent, canActivate: [AuthGuard] },
  { path: 'extra/:ean13', component: ExtraFormComponent, canActivate: [AuthGuard] },

  // ====== TEST ======
  { path: 'test/form-validation-sample', component: FormValidationSampleComponent },
  { path: 'test/form-validation-custom', component: FormValidationCustomComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [
    AppAuthService,
    AuthGuard,
    AdminAuthGuard,
  ]
})
export class RoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/routing/routing.module.ts